<div class="modal-header text-center">
  <div class="h5-text modal-title w-100" id="ContinueOnModalLabel">Continue On</div>
  <button type="button" class="close" (click)="continueOnSite()" aria-label="Close">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body text-center">
  <button (click)="continueOnApp()" class="btn-primary" data-dismiss="modal">Mobile App</button>
  <button (click)="continueOnSite()" class="btn-secondary" data-dismiss="modal">Website</button>
</div>
